define('controllers/myaccount',['require'],function(require) {
    return function() {
        $(window).load(function () {
            $(".datePicker").datepicker();
        });

        $("#btnUserSave").on("click", function (e) {
            if (window.Page_ClientValidate == undefined || Page_ClientValidate('UserInformationStep')) {
                var $this = $("#btnUserSave");
                $this.hide(); $this.next().fadeIn('slow');
            } else {
                e.preventDefault();
            }
        });
    };
});
